import { createApi } from '@reduxjs/toolkit/query/react';

import { CLIENTS_CHUNK, DELETE, GET, POST } from '@app/constants';
import { customBaseQuery } from '@app/services/rtkQuery/baseQuery';
import type {
  ModelClientSearchFilter,
  NClientsApi,
} from '@app/services/rtkQuery/Clients/types';
import type { NAuth, NClients, WithActiveBranchId } from '@app/types';

enum Endpoints {
  GetClientsFilterData = 'GetClientsFilterData',
  SearchClients = 'SearchClients',
}
export const clientsApi = createApi({
  reducerPath: 'clientsApi',
  baseQuery: ({ url, ...props }) =>
    customBaseQuery({ url: `${CLIENTS_CHUNK}/${url}`, ...props }),
  endpoints: ({ mutation, query }) => ({
    DeleteClientsBySearchId: mutation<
      NClientsApi.DeleteClientsBySearchIdResponse,
      NClientsApi.DeleteClientsBySearchIdRequest
    >({
      query: (params) => ({
        url: 'DeleteClientsBySearchId',
        method: POST,
        params,
      }),
    }),
    StopImportClientsExcel: mutation<
      void,
      {
        ActiveBranchId: NAuth.UserPrint['activeBranchId'];
      }
    >({
      query: (params) => ({
        url: 'StopImportExcel',
        method: DELETE,
        params,
      }),
    }),
    FindClientsByPhone: query<
      NClientsApi.FindClientsByPhoneResponse,
      NClientsApi.FindClientsByPhoneRequest
    >({
      query: (params) => ({
        url: 'FindClientsByPhone',
        method: GET,
        params,
      }),
    }),
    [Endpoints.GetClientsFilterData]: query<
      NClients.ModelClientsFilterData,
      WithActiveBranchId
    >({
      query: (params) => ({
        url: Endpoints.GetClientsFilterData,
        method: GET,
        params,
      }),
    }),

    [Endpoints.SearchClients]: query<
      NClients.ModelClientSearchResult,
      WithActiveBranchId<ModelClientSearchFilter>
    >({
      query: ({ ActiveBranchId, ...data }) => ({
        url: Endpoints.SearchClients,
        method: POST,
        params: { ActiveBranchId },
        data,
      }),
    }),
  }),
});

export const {
  useDeleteClientsBySearchIdMutation,
  useStopImportClientsExcelMutation,
  useFindClientsByPhoneQuery,
  useLazyFindClientsByPhoneQuery,
  useGetClientsFilterDataQuery,
  useSearchClientsQuery,
  useLazySearchClientsQuery,
} = clientsApi;
